import React, { useState } from "react";
import VoiceCloningIcon from "../../assets/images/voice cloning Interface.svg";
import { Card } from "../../components/Card";
import { Button, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

function VoiceCloningLanding() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    return (
        <Card>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                    gap: 4,
                    textAlign: "center",
                }}
            >
                <Box
                    component="img"
                    src={VoiceCloningIcon}
                    alt="Newsletter Icon"
                    sx={{
                        height: "10rem",
                        width: "10rem",
                    }}
                />
                <Typography variant="h6" color="textPrimary">
                    No Sound Cloning Created Yet
                </Typography>
                <Typography
                    variant="body1"
                    color="textSecondary"
                    sx={{
                        maxWidth: "60%",
                        margin: "0 auto",
                    }}
                >
                    It looks like you have not cloned any sound yet. Start
                    uploading sound and clone it to generate different speeches
                    through input commands . Its simple and easy.
                </Typography>
                <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate("create")}
                    sx={{
                        textTransform: "none",
                    }}
                >
                    + Clone New Sound
                </Button>
                {/* <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate("/dashboard/voice-cloning/chat")}
                    sx={{
                        textTransform: "none",
                    }}
                >
                    go to chat
                </Button>
                <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate("list")}
                    sx={{
                        textTransform: "none",
                    }}
                >
                    go to List
                </Button> */}
                {/* <Button variant="contained" onClick={() => setOpen(true)}>
                    + Clone New Sound
                </Button> */}
            </Box>
        </Card>
    );
}

export default VoiceCloningLanding;
